<template>
  <figure
    :class="[right && `${right}-right`, left && `${left}-left`]"
    :style="[
      minWidth && `min-width: ${minWidth};`,
      maxWidth && `max-width: ${maxWidth};`,
      width && `width: ${width};`,
      minHeight && `min-height: ${minHeight};`,
      maxHeight && `max-height: ${maxHeight};`,
      height && `height: ${height};`
    ]"
  >
    <slot />
    <figcaption v-if="hasFigcaption">
      <slot name="figcaption" />
    </figcaption>
  </figure>
</template>
<script>
import { computed } from "vue";
export default {
  props: {
    right: {
      type: String
    },
    left: {
      type: String
    },
    maxWidth: {
      type: String
    },
    minWidth: {
      type: String
    },
    width: {
      typ: String
    },
    maxHeight: {
      type: String
    },
    minHeight: {
      type: String
    },
    height: {
      type: String
    }
  },
  setup(props, ctx) {
    const hasFigcaption = computed(() => {
      return ctx.slots.figcaption ? true : false;
    });
    return {
      hasFigcaption
    };
  }
};
</script>
<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
figure {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 1.5em auto;
  figcaption {
    color: #adadad;
  }
}
@media (min-width: variables.$sm) {
  figure {
    &.sm-right {
      float: right;
      margin: 1em 0 1em 1.5em;
    }
    &.sm-left {
      float: left;
      margin: 1em 1.5em 1em 0;
    }
  }
}
@media (min-width: variables.$md) {
  figure {
    &.md-right {
      float: right;
      margin: 1em 0 1em 1.5em;
    }
    &.md-left {
      float: left;
      margin: 1em 1.5em 1em 0;
    }
  }
}
@media (min-width: variables.$lg) {
  figure {
    &.lg-right {
      float: right;
      margin: 1em 0 1em 1.5em;
    }
    &.lg-left {
      float: left;
      margin: 1em 1.5em 1em 0;
    }
  }
}
@media (min-width: variables.$xl) {
  figure {
    &.xl-right {
      float: right;
      margin: 1em 0 1em 1.5em;
    }
    &.xl-left {
      float: left;
      margin: 1em 1.5em 1em 0;
    }
  }
}
</style>
